var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{on:{"click":_vm.onChoose}},[_vm._t("default"),(!this.$slots.default)?_c('button',[_vm._v("Open google chooser")]):_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }